import React, { CSSProperties, useContext } from "react";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwTranslate from "../../shared/OwTranslate/OwTranslate";
import OwButton from "../../shared/OwButton/OwButton";
import SupplierContext from "../../../contexts/SupplierContext";
import "./CustomerModuleInactive.scss";

type Props = {
    logoutFn: () => void;
};

export const CustomerModuleInactive = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    const style: CSSProperties = {
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
        position: "absolute",
        zIndex: 100,
        backgroundColor: "rgba(0, 0, 0, 0.85)",
    };

    return (
        <div className={"CustomerModuleInactive"} style={style}>
            <div className={"mb-3"}>
                <OwTitle
                    title={"customer_access_module_inactive"}
                    className={"mb-2 text-warning"}
                    leftIconName={"fad fa-exclamation-triangle"}
                />
            </div>
            <div className={"mb-3"}>
                <OwTranslate
                    id={"please_contact_supplier_for_support"}
                    defaultMessage={"Please contact {supplier} for support."}
                    values={{ supplier: supplierModel.name }}
                />
            </div>
            <div className={"mt-2"}>
                <div>
                    <OwButton title={"logout"} fn={props.logoutFn} />
                </div>
            </div>
        </div>
    );
};
